'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
require('./MobileProfileIcon.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MobileProfileIcon = function (props) {
    var isAuthenticated = props.isAuthenticated, isAgent = props.isAgent, initialName = props.initialName, handleLogout = props.handleLogout, NextLink = props.NextLink;
    var _a = React__default['default'].useState(false), showList = _a[0], setShowList = _a[1];
    if (isAuthenticated && isAgent) {
        return (React__default['default'].createElement(React__default['default'].Fragment, null,
            React__default['default'].createElement("button", { className: "mobileProfileIcon__icon--initialName", type: "button", onClick: function () { return setShowList(!showList); } }, initialName),
            showList && (React__default['default'].createElement("div", { className: 'mobileProfileIcon__menu' },
                NextLink
                    ? (React__default['default'].createElement(NextLink, { href: "/agents/profile/" },
                        React__default['default'].createElement("a", { title: "Lifepal Agents" }, "Profil")))
                    : (React__default['default'].createElement("a", { title: "Lifepal Agents", href: "/agents/profile/" }, "Profil")),
                React__default['default'].createElement("a", { onClick: function () { return handleLogout(); } }, "Keluar")))));
    }
    else if (!isAuthenticated) {
        if (NextLink) {
            return (React__default['default'].createElement(NextLink, { href: "/account/login/" },
                React__default['default'].createElement("a", { className: "mobileProfileIcon__icon", title: "Login" },
                    React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--profile" }))));
        }
        else {
            return (React__default['default'].createElement("a", { className: "mobileProfileIcon__icon", title: "Login", href: "/account/login/" },
                React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--profile" })));
        }
    }
    else {
        return React__default['default'].createElement(React__default['default'].Fragment, null);
    }
};

module.exports = MobileProfileIcon;
//# sourceMappingURL=MobileProfileIcon.js.map
